let defaults = {

	defaultSymbols: ['DJI', 'SPX', 'COMP', 'CY:OIL', 'CY:GOLD', 'USAYIELD10YR', 'USD-EUR', '^FTSE', '^N225'],

	chart: {
		// 0= filled area chart
		type: 2,

		/**	Do/don't show supplementary volume graph [2]
		 *	0 = don't show volume graph
		 *	1 = show monochrome volume graph
		 *	2 = show volume graph colored by price increase vs. decrease
		 */
		volume: 0,

		// Chart and footer box bg shadow/extrusion thickness in px
		shwidth: 0,

		// Filled area chart translucency in percent
		fillalpha: 60,

		// Canvas background color
		ibcolor: 'null',

		// Price region background color
		bgcolor: 'FFFFFF',

		// Volume region background color
		// bvcolor: '',

		// Filled area chart color, ignored if a gradient is used [4]
		arcolor: '009fdb',

		// Comma-delimited list of value line colors, corresponding to tickers
		lncolor: 'FFFFFF',

		// Volume bar color if volume=1
		// vocolor: '',

		// Price & volume graph border & tick color
		brcolor: '009fdb',

		// Price & volume graph shadow/extrude color
		// shcolor: '',

		// Price & volume graph grid line color (major)
		grcolor: 'DDDDDD',

		// Price & volume graph grid line color (minor)
		gmcolor: 'DDDDDD',

		// Intraday chart previous close line color
		mkcolor: '',

		// Text color for axis labels, attribution, etc., and tickers if legend is outside chart [5]
		txcolor: '444444',

		// Ticker symbol legend text color if legend is inside chart [5]
		itcolor: '000000'

		// Filled area chart gradient color (top/left)
		// gtcolor: '',

		// Filled area chart gradient color (bottom/right)
		// gbcolor: ''
	},
	tertiaryNavigation: {
		desktop: {
			stock: [
				{
					url: '/finance/category/stockdetail/symbol/{symbol}',
					label: 'Overview',
					lite: true
				},
				{
					url: '/finance/category/stockdetail/section/profile/symbol/{symbol}',
					label: 'Profile'
				},
				{
					url: '/finance/category/stockdetail/section/key-statistics/symbol/{symbol}/',
					label: 'Statistics'
				},
				{
					url: '/finance/category/stockdetail/section/historical-data/symbol/{symbol}',
					label: 'Historical Data',
					lite: true
				},
				{
					url: '/finance/category/stockdetail/section/analysts/symbol/{symbol}',
					label: 'Analysts'
				},
				{
					url: '/finance/category/stockdetail/section/financials/symbol/{symbol}',
					label: 'Financials'
				},
				{
					url: '/finance/category/stockdetail/section/holdings/symbol/{symbol}',
					label: 'Holdings'
				}
			],
			default: [
				{
					url: '/finance/category/stockdetail/symbol/{symbol}',
					label: 'Overview',
					lite: true
				},
				{
					url: '/finance/category/stockdetail/section/historical-data/symbol/{symbol}',
					label: 'Historical Data',
					lite: true
				}
			]
		},
		phone: {
			stock: [
				{
					url: '/finance/category/stockdetail/symbol/{symbol}',
					label: 'Overview',
					lite: true
				},
				{
					url: '/finance/category/stockdetail/section/key-statistics/symbol/{symbol}/',
					label: 'Statistics'
				},
				{
					url: '/finance/category/stockdetail/section/news/symbol/{symbol}',
					label: 'News',
					limitedLocales: ['es'],
					lite: true
				}
			],
			default: [
				{
					url: '/finance/category/stockdetail/symbol/{symbol}',
					label: 'Overview',
					lite: true
				}
			]
		}
	}
};

export default defaults;
